'use strict';

var Type = require('../type');

function resolveYamlMerge(data) {
  return data === '<<' || data === null;
}

module.exports = new Type('tag:yaml.org,2002:merge', {
  kind: 'scalar',
  resolve: resolveYamlMerge
});



//////////////////
// WEBPACK FOOTER
// ./~/js-yaml/lib/type/merge.js
// module id = 119
// module chunks = 0